
import {defineComponent} from 'vue';
import InputLagGame from "@/components/InputLagGame.vue";

export default defineComponent({
  name: 'HomeView',
  components: {InputLagGame},
});
